import { useIntl } from "react-intl";

export default function useAccessiblePageTitle(title: string) {
  const intl = useIntl();
  return intl.formatMessage({ defaultMessage: "{title} Content" }, { title });
}
